import * as React from 'react'

const sizeDefault = {
  x: 36,
  y: 16,
}

export interface IProps {
  size?: { x: number; y: number }
  style?: React.CSSProperties
}
export const TriangleArrow: React.FCC<IProps> = ({
  size = sizeDefault,
  style,
}) => (
  <svg
    width={size.x}
    height={size.y}
    viewBox="0 0 36 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.8848 8.5H5.54077V12.739L0.999767 8L5.54077 3.261V7.5H34.8848V8.5Z"
      fill="var(--figma-color-text, rgba(0, 0, 0, 0.8))"
    />
  </svg>
)
